<div class="wrapper-lg">
    <app-breadcrumbs [items]="[
                     { url: '/health-ministry-dashboard', text: 'healthMinistryDashboard_title' },
                     { text: person?.CertNumber }
                     ]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{person?.Name}} {{person?.Surname}}
            <app-health-ministry-resident-status [id]="person?.StudentStatusId"
                                                 [name]="person?.StudentStatusName">
            </app-health-ministry-resident-status>
        </h1>
        <aside>
            <a target="_blank" class="btn btn-outline" [routerLink]="['/plan-summary'] | localize" [queryParams]="{ StudentEmail: person?.StudentUpn }">
                {{'healthMinistryDashboard_btnPlanSummary' | translate}}
            </a>
        </aside>
    </header>

    <div class="content-desc">
        {{person?.CertNumber}}
        <ng-container *ngIf="person?.StudyProgramName"> &bull; {{person?.StudyProgramName}}</ng-container>
        <ng-container *ngIf="person?.UniversityName"> &bull; {{person?.UniversityName}}</ng-container>
    </div>

    <ng-container>
        <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabId" class="nav-tabs">
            <li [ngbNavItem]="1">
                <a ngbNavLink [routerLink]="['/health-ministry-dashboard/residents', id] | localize" [queryParams]="{ tab: 'info' }">
                    {{'healthMinistryDashboard_residentInfo' | translate}}
                </a>
                <ng-template ngbNavContent>
                    <section class="block mb-0">
                        <div class="row">
                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblMedicalPersonId' | translate}}</label>
                                <div>{{person?.MedicalPersonId || undefinedString}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblStudyYear' | translate}}</label>
                                <div>{{person?.StudyYear || undefinedString}}</div>
                            </div>

                            <div class="col"></div>
                        </div>

                        <div class="row">
                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblSpeciality' | translate}}</label>
                                <div>{{person?.StudyProgramName || undefinedString}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblSpecialityType' | translate}}</label>
                                <div>{{person?.StudyProgramSpecialityTypeName || undefinedString}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblSpecialityManager' | translate}}</label>
                                <div *ngIf="person?.StudyProgramManagerName; else noManager">{{person?.StudyProgramManagerName}} {{person?.StudyProgramManagerSurname}}</div>
                                <ng-template #noManager>
                                    <div>{{undefinedString}}</div>
                                </ng-template>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblStudyBeginDate' | translate}}</label>
                                <div>{{(person?.StudyBeginDate | appDate) || undefinedString}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblPlannedEndDate' | translate}}</label>
                                <div>{{(person?.StudyPlannedEndDate | appDate) || undefinedString}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblStudyProgramLength' | translate}}</label>
                                <div>{{person?.StudyProgramLengthInYears || undefinedString}}</div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblEcts' | translate}}</label>
                                <div>{{person?.StudyProgramEcts || undefinedString}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblFinancing' | translate}}</label>
                                <div>{{person?.StudyTypeName || undefinedString}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblFinancingType' | translate}}</label>
                                <div>{{person?.StudyFinanceTypeName || undefinedString}}</div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblUniversity' | translate}}</label>
                                <div>{{person?.UniversityName || undefinedString}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblWorkplace' | translate}}</label>
                                <div>{{person?.WorkplaceName || undefinedString}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblClinicalBase' | translate}}</label>
                                <div>{{person?.ClinicalBaseName || undefinedString}}</div>
                            </div>
                        </div>
                    </section>

                    <section class="block mt-2">
                        <header class="block-header">
                            <h5>{{'healthMinistryDashboard_statusHistory' | translate}}</h5>
                        </header>
                        <app-table [rows]="data?.StudentStatusHistory || []" [columns]="statusColumns">
                            <ng-template #rowTemplate let-row>
                                <tr>
                                    <td>
                                        <app-health-ministry-resident-status [id]="row.StatusId" [name]="row.StatusName">
                                        </app-health-ministry-resident-status>
                                    </td>
                                    <td>{{row.DateFrom | appDate}}</td>
                                    <td>{{row.DateTo | appDate}}</td>
                                </tr>
                            </ng-template>
                        </app-table>
                    </section>

                    <section class="block">
                        <header class="block-header">
                            <h5>{{'healthMinistryDashboard_studyHistory' | translate}}</h5>
                        </header>
                        <app-table [rows]="data?.StudyProgramHistory || []" [columns]="studyColumns">
                            <ng-template #rowTemplate let-row>
                                <tr>
                                    <td>{{row.StudyProgramName}}</td>
                                    <td>
                                        <app-health-ministry-resident-status [id]="row.StudentStatusId"
                                                                             [name]="row.StudentStatusName">
                                        </app-health-ministry-resident-status>
                                    </td>
                                    <td>{{row.Date | appDate}}</td>
                                    <td>
                                        <a *ngIf="row.StudentId != person?.StudentId"
                                           [routerLink]="[] | localize"
                                           [queryParams]="{ StudentId: row.StudentId }">
                                            {{'healthMinistryDashboard_btnViewCard' | translate}}
                                        </a>
                                    </td>
                                </tr>
                            </ng-template>
                        </app-table>
                    </section>
                </ng-template>
            </li>

            <li [ngbNavItem]="2">
                <a ngbNavLink [routerLink]="['/health-ministry-dashboard/residents', id] | localize" [queryParams]="{ tab: 'breaks' }">
                    {{'healthMinistryDashboard_studyBreaks' | translate}}
                </a>
                <ng-template ngbNavContent>
                    <section class="block mb-0">
                        <div class="data-value">
                            <label>{{'healthMinistryDashboard_lblPlannedEndDate' | translate}}</label>
                            <div>{{person?.StudyPlannedEndDate | appDate}}</div>
                        </div>
                    </section>

                    <section class="block mt-2">
                        <header class="block-header">
                            <h5>{{'healthMinistryDashboard_academicVacations' | translate}}</h5>
                        </header>
                        <app-table [rows]="data?.AcademicVacations || []" [columns]="vacationColumns">
                            <ng-template #rowTemplate let-row>
                                <tr>
                                    <td>{{row.StudyYear}}</td>
                                    <td>{{row.DateFrom | appDate}}</td>
                                    <td>{{row.DateTo | appDate}}</td>
                                    <td>{{row.Resumpted | appDate}}</td>
                                </tr>
                            </ng-template>
                        </app-table>
                    </section>
                </ng-template>
            </li>

            <li [ngbNavItem]="3">
                <a ngbNavLink [routerLink]="['/health-ministry-dashboard/residents', id] | localize" [queryParams]="{ tab: 'workplace' }">
                    {{'healthMinistryDashboard_workplace' | translate}}
                </a>
                <ng-template ngbNavContent>
                    <section class="block mb-0">
                        <div class="row">
                            <div class="col data-value ">
                                <label>{{'healthMinistryDashboard_lblActualWorkplace' | translate}}</label>
                                <div>{{person?.WorkplaceName}}</div>
                            </div>

                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblActualClinicalBase' | translate}}</label>
                                <div>{{person?.ClinicalBaseName}}</div>
                            </div>
                        </div>
                    </section>

                    <section class="block mt-2">
                        <header class="block-header">
                            <h5>{{'healthMinistryDashboard_workplaceHistory' | translate}}</h5>
                        </header>
                        <app-table [rows]="data?.WorkplaceHistory || []" [columns]="workplaceColumns">
                            <ng-template #rowTemplate let-row>
                                <tr>
                                    <td>{{row.CompanyName}}</td>
                                    <td>{{row.DateFrom | appDate}}</td>
                                    <td>{{row.DateTo | appDate}}</td>
                                </tr>
                            </ng-template>
                        </app-table>
                    </section>

                    <section class="block">
                        <header class="block-header">
                            <h5>{{'healthMinistryDashboard_clinicalBaseHistory' | translate}}</h5>
                        </header>
                        <app-table [rows]="data?.ClinicalBaseHistory || []" [columns]="clinicalBaseColumns">
                            <ng-template #rowTemplate let-row>
                                <tr>
                                    <td>{{row.CompanyName}}</td>
                                    <td>{{row.DateFrom | appDate}}</td>
                                    <td>{{row.DateTo | appDate}}</td>
                                </tr>
                            </ng-template>
                        </app-table>
                    </section>
                </ng-template>
            </li>

            <li [ngbNavItem]="4">
                <a ngbNavLink [routerLink]="['/health-ministry-dashboard/residents', id] | localize" [queryParams]="{ tab: 'financing' }">
                    {{'healthMinistryDashboard_financing' | translate}}
                </a>
                <ng-template ngbNavContent>
                    <section class="block mb-0">
                        <div class="row">
                            <div class="col data-value">
                                <label>{{'healthMinistryDashboard_lblActualFinancing' | translate}}</label>
                                <div>{{person?.WorkplaceName}}</div>
                            </div>
                        </div>
                    </section>

                    <section class="block mt-2">
                        <header class="block-header">
                            <h5>{{'healthMinistryDashboard_financingHistory' | translate}}</h5>
                        </header>
                        <app-table [rows]="data?.StudyTypeHistory || []" [columns]="studyTypeColumns">
                            <ng-template #rowTemplate let-row>
                                <tr>
                                    <td>{{row.StudyTypeName}}</td>
                                    <td>{{row.DateFrom | appDate}}</td>
                                    <td>{{row.DateTo | appDate}}</td>
                                </tr>
                            </ng-template>
                        </app-table>
                    </section>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>
    </ng-container>
</div>
